<template>
    <b-card border-variant="dark" class="mt-4">
      <div class="height-queue">
        <span class="font-weight-bold font-15">Atendimento por Operador</span>
        <b-table id="queue" small striped bordered fixed :per-page="perPage" :fields="fields" :items="items"
          responsive="sm" class="mt-2" :current-page="currentPage" show-empty>
          <template #empty="scope">
            <h6 class="text-center">Nenhum cliente na fila</h6>
          </template>
  
          <template #cell(queue)="data">
            <span :class="data.item.queue == 'Atendimento Ativo' ? 'text-danger font-weight-bold' : ''">{{ data.item.queue
              }}</span>
          </template>
        </b-table>
        <b-pagination v-model="currentPage" pills :total-rows="rows" :per-page="perPage" aria-controls="queue" size="sm"
          align="right"></b-pagination>
      </div>
    </b-card>
  </template>
  
  <script>
  const { socketWpp } = require('./../../../modules/realtime/service/service');
  
  export default {
    name: "TbFilaAtendimentoOperador",
  
    data: () => ({
      fields: [
        { key: 'operator', label: 'Operador', class: 'text-center align-middle', thStyle: { 'font-weight': 'bold', padding: '3px' } },
        { key: 'atendimento', label: 'Quantidade', class: 'text-center align-middle', thStyle: { 'font-weight': 'bold', padding: '3px' } },
      ],
      currentPage: 1,
      perPage: 10,
      queues: [],
      userChatQueues: [],
      users: [],
      attFilter: '*',
      items: []
    }),
  
    created() {
    axios.get('/user-chat-queues').then(({ data }) => {
      this.userChatQueues = data;
      this.userChatQueues.push('entrante');
    });

    axios.get('/realtime/listUsersChat', {}).then(({ data }) => {
      this.users = data;
    });

    socketWpp.on('queueAttend', (obj) => {
      this.queues = obj.queues || [];
    });
  },

  computed: {
    rows() {
      return this.items.length;
    }
  },

  methods: {

    getItems() {
      if (this.attFilter == 'receptivo') {
        this.items = this.mountTable().filter((val) => {
          if (val.queue != 'Ativo') return true;
        });
      } else if (this.attFilter == 'ativo') {
        this.items = this.mountTable().filter((val) => {
          if (val.queue == 'Ativo') return true;
        });
      } else {
        this.items = this.mountTable();
      }
    },

    mountTable() {
        const operatorClients = {}; // Objeto para agrupar os clientes por operador

        this.queues.forEach(q => {
            if (this.userChatQueues.includes(q.queue)) {
            let userOperator = this.users.find(o => o.id == q.operator);
            const operatorName = userOperator?.nome ? userOperator.nome : q.operator;

            // Adicionar ao agrupamento por operador
            if (!operatorClients[operatorName]) {
                operatorClients[operatorName] = 0;
            }
            operatorClients[operatorName]++;
            }
        });

        // Criar o resumo final com quantidade de clientes por operador
        const result = Object.keys(operatorClients).map(operator => ({
            operator: operator,
            atendimento: operatorClients[operator]
        }));

        return result;
    },

  },

  watch: {
    async queues() {
      this.getItems()
    },
    attFilter() {
      this.getItems();
    }
  }

}
  </script>
  
  <style scoped>
  .card {
    color: black !important;
    border: 1px solid rgba(0, 0, 0, 0.125) !important;
    border-radius: 0.25rem !important;
  }
  
  .font-15 {
    font-size: 15px;
  }
  
  .height-queue {
    /* height: 205px; */
  }
  </style>